import { H2, Text, color, space } from '@ticketswap/solar'
import styled from '@emotion/styled'
import { useQuery } from '@apollo/client'
import { GET_NEARBY } from '~/graphql/queries/getNearby'
import NearbyEvents from './NearbyEvents'
import NearbyLocations from './NearbyLocations'
import { useGeoInfo } from '~/components/GeoInfoContext'
import PropTypes from '~/lib/propTypes'

const StyledText = styled(Text)`
  color: ${color.foregroundMuted};
`

const Locations = styled.div`
  margin-block-start: ${space[16]};
`

const Events = styled.div`
  margin-block-start: ${space[16]};
`

const DiscoverNearby = ({ t }) => {
  const geoInfo = useGeoInfo()
  const { latitude, longitude } = geoInfo
  const { data, loading } = useQuery(GET_NEARBY, {
    variables: {
      latitude,
      longitude,
    },
  })

  const hasData = Boolean(data?.nearby)

  if (!loading && !hasData) return null

  const events = (hasData && data.nearby.risingEvents) || []
  const locations = (hasData && data.nearby.popularLocations) || []

  return (
    <>
      <Events>
        <H2>{t('home:discover.nearby.events.title')}</H2>
        <StyledText as="p">{t('home:discover.nearby.events.subtitle')}</StyledText>
        <NearbyEvents loading={loading} events={events} />
      </Events>

      <Locations>
        <H2>{t('home:discover.nearby.locations.title')}</H2>
        <StyledText as="p">{t('home:discover.nearby.locations.subtitle')}</StyledText>
        <NearbyLocations loading={loading} locations={locations} />
      </Locations>
    </>
  )
}

DiscoverNearby.propTypes = {
  t: PropTypes.func.isRequired,
}

export default DiscoverNearby
